import {keyBy} from 'lodash-es'
import scrollbarPrettify from '../../../directives/scrollbar-prettify'
const pcSelectorMixin = {
  directives: {
    scrollbarPrettify
  },
  data () {
    return {
      height: 32,
      // popper 宽度
      realPopperWidth: this.popperWidth
    }
  },
  computed: {
    // 选中的第一个节点展示的文字
    firstNodeText: function () {
      return (this.showedSelectedNodes.length && this._getShowText(this.showedSelectedNodes[0])) || ''
    },
    firstNodeCompleteText: function () {
      return (this.showedSelectedNodes.length && this._getShowText(this.showedSelectedNodes[0], true)) || ''
    },
    disabledKeysSet: function () {
      return new Set(this.disabledKeys)
    }
  },
  created () {
    // 设置高度
    if (this.size === 'mini') {
      this.height = 28
    }
  },
  methods: {
    // 响应tree 的 change事件
    _changeHandler (selectedNodes, silent) {
      this.selectedNodes = selectedNodes
      this._change(silent)
    },
    // 选中的数据集发生变化
    // completeNodes、simpleNodes、complete、simple、unInitSelectedKeys 等都在之前的环节设置好
    _change (silent = false) {
      // console.log('tree-selector change', silent)
      const selectedNodes = this.selectedNodes
    
      // 构建showedSelectedNodes
      let candidateShowNodes = this._getUninitShowedNodes(selectedNodes.unInitSelectedKeys)
      this.showedSelectedNodes = candidateShowNodes.concat(selectedNodes.simpleNodes)
    
      // 更新高度
      this.$refs['magicInput'] && this.$refs['magicInput'].updateHeight()
    
      // 构建最新的 selectedKeys
      let selectedKeys = selectedNodes.simpleNodes.map(node => node.key)
      selectedKeys = selectedKeys.concat(selectedNodes.unInitSelectedKeys)
    
      // selectedData 所有选中项的 data 数组
      const selectedDataMap = keyBy(this.selectedData, this.keys['key'])
      selectedNodes.selectedData = selectedNodes.unInitSelectedKeys.map(_ => selectedDataMap[_])
        .concat(selectedNodes.simple)
    
      // 通知
      !silent && this.$emit('update:selectedKeys', selectedKeys)
      this.$emit(silent ? 'silent-change' : 'change', selectedNodes, [...selectedKeys], this.preSelectedKeys)
      
      // 记录 preSelectedKeys
      this.preSelectedKeys = [...selectedKeys]
    },
    // 展示dropdown
    _open () {
      if (this.visible || this.disabled) return
      this.visible = true
      if (!this.shouldTreeCreate) {
        this.shouldTreeCreate = true
      }
    },
    // 隐藏dropdown
    _close () {
      // console.log('hide')
      if (!this.visible) return
      this.visible = false
      this.$refs['magicInput'].clearFilter()
    },
    // toggle dropdown的显示/隐藏
    _toggleVisible (e) {
      // console.log('toggle')
      if (this.visible) {
        this._close()
        // 阻止由于clickoutside导致的展开
        e.stopPropagation()
      } else {
        this._open()
      }
    },
    // 搜索结果变化
    _filterItemsChange () {
      this.$nextTick(() => {
        this.updatePopover()
      })
    },
    // 当filterKw为空时，filter-list会销毁，因此只能在此updatePopover
    _nextUpdatePopper () {
      if (!this.filterKw.length) {
        this.updatePopover(true)
      }
    },
    // 单选时，清空输入框
    _singleClear () {
      if (!this._getCoreRef()) {
        this.realSelectedKeys = []
        this._updateUnInitSelectedKeys()
        this._change(false)
      } else {
        this._getCoreRef()._updateSelectedNodesSingle(null, false, null, true)
      }
      this.$emit('clear')
    },
    // 更新正式的 popper 宽度
    _realPopperWidthUpdate (width) {
      this.realPopperWidth = width
    },
    // 外部接口 - popover 更新，也被内部使用
    async updatePopover (nextTick = false) {
      if (nextTick) {
        await this.$nextTick()
      }
      this.$refs['magicInput'] && this.$refs['magicInput'].updatePopper()
    }
  }
}

export default pcSelectorMixin